import React from 'react'
import PartyItem from '../../../../../components/party'
import { AdminManageGeneralChartState } from '../../hooks/use-admin-manage-general-chart'

const ManageGeneralChartParties: React.FC<{
  state: AdminManageGeneralChartState
}> = ({ state }) => {
  const {
    moveParty,
    addPoliticalParty,
    form: { register, getValues, setValue, watch },
    partiesFieldArray: { fields },
    mode: formMode,
  } = state
  const [partyName, setPartyName] = React.useState('')
  const [partyAbbreviation, setPartyAbbreviation] = React.useState('')

  const addNewParty = () => {
    // update our parent state
    addPoliticalParty(partyName, partyAbbreviation)
    //clear our local state
    setPartyName('')
    setPartyAbbreviation('')
  }

  const partyCanBeAdded = () => {
    return partyName.length > 0 && partyAbbreviation.length > 0
  }

  return (
    <>
      <div className="mt-8 font-medium tracking-widest uppercase">Parties</div>
      <div className="container p-8 mx-auto mt-2 border border-opacity-50 rounded-md border-primary-blue">
        <div className="flex gap-4">
          <input
            type="text"
            placeholder="New Party Name"
            className="w-64 px-4 py-3 border rounded-md border-primary-blue"
            value={partyName}
            onChange={(e) => setPartyName(e.target.value)}
          />
          <input
            type="text"
            placeholder="New Party Abbreviation"
            className="w-64 px-4 py-3 border rounded-md border-primary-blue"
            value={partyAbbreviation}
            onChange={(e) => setPartyAbbreviation(e.target.value)}
          />
          <button
            className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            disabled={!partyCanBeAdded()}
            onClick={() => {
              addNewParty()
            }}
          >
            Add Party
          </button>
        </div>
        <div className="mt-8 font-bold">
          Select all applicable parties and order in accordance to your ballot
        </div>
        <div className="flex flex-wrap gap-2 mt-5">
          {fields.map((party, i) => (
            <div className="flex" key={party.id}>
              <PartyItem
                index={i}
                party={party}
                register={register}
                moveParty={moveParty}
                mode={formMode}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ManageGeneralChartParties
